import $ from 'jquery';
export default class ProductImageBox {
	init() {
		$(document).ready(function(){
			var $modal = $('#product-modal');
			if($modal.length){
				var $imgBox = $('.product-modal-images',$modal);
				var orgWidth = $imgBox.data('width'), orgHeight = $imgBox.data('height');
				var orgVThumbWidth = 200;
				var orgVerHeight = ((750-orgVThumbWidth-5)/orgWidth)*orgHeight;
				
				function getSliderConfig(vertical,verticalHeight,vThumbWidth){
					if(typeof vertical === 'undefined'){
						vertical = true;
					}
					if(typeof verticalHeight === 'undefined'){
						verticalHeight = orgVerHeight;
					}
					if(typeof vThumbWidth === 'undefined'){
						vThumbWidth = orgVThumbWidth;
					}
					return {
						gallery:true,
						item:1,
						vertical: vertical,
						verticalHeight: verticalHeight,
						vThumbWidth: vThumbWidth,
						thumbItem: 4,
						thumbMargin:4,
						slideMargin: 10
					}
				}
				var buildTimeout = false;
				var curWinWidth = $(window).width();
				var adapt = 990;
	
				function changeAdapt(adaptWidth){
					if(typeof adaptWidth === 'undefined'){
						adaptWidth = 768;
					}
					var curWinWidth = $(window).prop('innerWidth');
					$(window).resize(function(){
						setTimeout(function(){
							var winWidth = $(window).prop('innerWidth');
							if( (curWinWidth < adaptWidth) && (winWidth >= adaptWidth) ){
								if(adaptWidth == 768){
									$(window).trigger('cdz_pc');
								}else{
									$(window).trigger('cdz_pc_' + adaptWidth);			
								}
							}else if( (curWinWidth >= adaptWidth) && (winWidth < adaptWidth)){
								if(adaptWidth == 768){
									$(window).trigger('cdz_mobile');
								}else{
									$(window).trigger('cdz_mobile_' + adaptWidth);
								}
							}
							curWinWidth = winWidth;
						},200);
					});
				}
				changeAdapt(adapt);
				window.pModalSlider = $imgBox.lightSlider(getSliderConfig());
				$(window).on('cdz_pc_' + adapt, function(){
					if (window.pModalSlider.lightSlider) {
						window.pModalSlider.destroy();
					}
					window.pModalSlider = $($imgBox).lightSlider(getSliderConfig());
				}).on('cdz_mobile_' + adapt,function(){
					if (window.pModalSlider.lightSlider) {
						window.pModalSlider.destroy();
					}
					window.pModalSlider = $('.product-modal-images',$modal).lightSlider(getSliderConfig(false));
				});
			}
		});
	}
}


// WEBPACK FOOTER //
// ./js/components/product-image-box.js